import React from 'react';
import { Form, Card, Alert } from 'react-bootstrap';
import { FileTextOutlined, InfoCircleOutlined } from '@ant-design/icons';

const TextSearchTab = ({ formData, handleChange }) => (
  <div className="mt-2">
    <Card className="glass-tab-card border-0">
      <Card.Body>
        <div className="d-flex align-items-center mb-1">
          <FileTextOutlined style={{ fontSize: '18px', color: '#34c759', marginRight: '8px' }} />
          <Card.Title className="mb-0" style={{ fontSize: '14px', color: '#1d1d1f' }}>
            Поиск по тексту
          </Card.Title>
        </div>
        <Alert variant="success" className="mb-2 py-1 px-2 border-0" style={{ fontSize: '12px', background: 'rgba(52, 199, 89, 0.1)', borderRadius: '10px' }}>
          <InfoCircleOutlined style={{ marginRight: '4px' }} />
          Введите текст для поиска на странице
        </Alert>
        <Form.Group className="mb-0">
          <Form.Label className="fw-semibold mb-1" style={{ fontSize: '13px', color: '#1d1d1f' }}>
            Текст для поиска <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            name="text"
            value={formData.text}
            onChange={handleChange}
            placeholder="Введите текст для поиска..."
            required={formData.searchType === 'text'}
            className="glass-input"
            style={{ resize: 'vertical', minHeight: '60px' }}
          />
          <Form.Text className="text-muted mt-0 d-block" style={{ fontSize: '11px' }}>
            Будет создан скриншот найденного фрагмента
          </Form.Text>
        </Form.Group>
      </Card.Body>
    </Card>
  </div>
);

export default TextSearchTab;

